import { useRef } from 'react';
function isFocusTarget(element) {
    return element instanceof HTMLElement && element !== document.body;
}
/**
 * Alla chiusura Radix riporta il focus solo sul proprio `Trigger`: un dialogo
 * aperto da codice (senza `DialogTrigger`, es. dal clic su una riga o dopo un
 * invio con errori) lo lasciava sul `body`, e chi usa la tastiera ripartiva
 * dall'inizio della pagina. Si ricorda l'elemento che aveva il focus
 * all'apertura e, se dopo la chiusura il focus è sul `body`, lo si riporta lì
 * (se è ancora nella pagina). Un `onCloseAutoFocus` del chiamante che chiama
 * `preventDefault` decide da sé, come in Radix.
 */
export function useRestoreFocusOnClose({ onOpenAutoFocus, onCloseAutoFocus, }) {
    const returnTargetRef = useRef(null);
    return {
        onOpenAutoFocus: (event) => {
            const active = document.activeElement;
            returnTargetRef.current = isFocusTarget(active) ? active : null;
            onOpenAutoFocus?.(event);
        },
        onCloseAutoFocus: (event) => {
            onCloseAutoFocus?.(event);
            if (event.defaultPrevented)
                return;
            const returnTarget = returnTargetRef.current;
            returnTargetRef.current = null;
            // Dopo il gestore di Radix, che sposta il focus sul Trigger se c'è.
            queueMicrotask(() => {
                if (isFocusTarget(document.activeElement))
                    return;
                if (returnTarget?.isConnected) {
                    returnTarget.focus({ preventScroll: true });
                }
            });
        },
    };
}
//# sourceMappingURL=use-restore-focus-on-close.js.map